import { Component, Input, OnInit } from '@angular/core';
import { BaseViewComponent, Orientation } from '@sb/library/base';

@Component({
    selector: 'lib-layout-row',
    templateUrl: './layout-row.component.html',
    styleUrls: ['./layout-row.component.scss']
})
export class LayoutRowComponent extends BaseViewComponent implements OnInit {
    @Input() hasBorder: boolean = false;

    readonly orientation: Orientation = this.isMobile ? Orientation.Vertical : Orientation.Horizontal;
}
